import * as React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import DataGrid from '../components/DataGrid';
import { GetPermissions } from '../components/Options';
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import GetColumnDefs from '../components/ColumnDefs';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { Button } from "@progress/kendo-react-buttons";
import { TextArea } from "@progress/kendo-react-inputs";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { TextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";

export const Reprint = (props) => {
    const [permissions, setPermissions] = React.useState(null);
    let dt = new Date();
    let dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()) };
    const [dateRange, setDateRange] = React.useState(dr);
    const [docket, setDocket] = React.useState("");
    const [docketText, setDocketText] = React.useState("");
    const [printText, setPrintText] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [snapshots, setSnapshots] = React.useState([]);
    const [firstWeighs, setFirstWeighs] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [rego, setRego] = React.useState("");
    const [selectedTrans, setSelectedTrans] = React.useState();
    const handleTabSelect = (e) => { setSelectedTab(e.selected); };
    const [columns, setColumns] = React.useState([
        { field: 'transactionId', label: 'Id', type: 'numeric', format: null, isVisible: false },
        { field: 'docket', label: 'Docket', type: 'text', format: null, isVisible: true },
        { field: 'registration1', label: 'Rego', type: 'text', format: null, isVisible: true },
        { field: 'transactionDate', label: 'Time', type: 'date', format: '{0:d/MM/yy hh:mm}', isVisible: true },
    ]);
    const [eventColumns, setEventColumns] = React.useState([
        { field: 'eventLogId', label: 'Id', type: 'numeric', format: null, isVisible: false },
        { field: 'eventDateTime', label: 'Date/Time', type: 'date', format: '{0:d/MM/yy hh:mm}', isVisible: true },
        { field: 'name', label: 'Name', type: 'text', format: null, isVisible: true },
        { field: 'comment', label: 'Details', type: 'text', format: null, isVisible: true },
    ]);
    const [offenceColumns, setOffenceColumns] = React.useState([
        { field: 'offenceId', label: 'Id', type: 'numeric', format: null, isVisible: false },
        { field: 'dateTimeIn', label: 'Date/Time', type: 'date', format: '{0:d/MM/yy hh:mm}', isVisible: true },
        { field: 'description', label: 'Details', type: 'text', format: null, isVisible: true },
    ]);
    const [historyParam, setHistoryParam] = React.useState("");
    const layout = props.layout;
    const transId = React.useRef(0);
    const [jobs, setJobs] = React.useState([]);
    const [job, setJob] = React.useState({ id: "0", name: "All" });
    const [customers, setCustomers] = React.useState([]);
    const [customer, setCustomer] = React.useState({ id: "0", name: "All" });
    const [products, setProducts] = React.useState([]);
    const [product, setProduct] = React.useState({ id: "0", name: "All" });
    const [sources, setSources] = React.useState([]);
    const [source, setSource] = React.useState({ id: "0", name: "All" });
    const [destinations, setDestinations] = React.useState([]);
    const [destination, setDestination] = React.useState({ id: "0", name: "All" });
    const cloudToken = props.cloudToken; 
    const [showDialog, setShowDialog] = React.useState(true);
    const title = document.title;
    const logo = props.logo;
    const rowRef = React.useRef({});
    const [lookupParams, setLookupParams] = React.useState();

    React.useEffect(() => {
        if (props && props.options) {
            setJobs(CreateList(props.options.jobs));
            setCustomers(CreateList(props.options.customers));
            setProducts(CreateList(props.options.products));
            setSources(CreateList(props.options.sources));
            setDestinations(CreateList(props.options.destinations));
            DoClear();
        }
    }, [props.options]);

    const CreateList = (d) => {
        var x = [{ id: "0", name: "All" }];
        return x.concat(d);
    };

    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }

    React.useEffect(() => {
        GetColumnDefs("DocketReprint", setColumns);
        GetPermissions(["ViewTransaction"], setPermissions);
    }, [])

    const DialogNo = () => {
        if (props.onClose) props.onClose();
    }

    const rangeChanged = (e) => {
        setDateRange(e.target.value);
    }

    const DoSearch = () => {
        setLookupParams(CreateParams(dateRange));
        setHistoryParam("");
        setDocketText("");
    }

    const DoClear = () => {
        setRego("");
        setDocket("");
        setJob({ id: "0", name: "All" });
        setCustomer({ id: "0", name: "All" });
        setProduct({ id: "0", name: "All" });
        setSource({ id: "0", name: "All" });
        setDestination({ id: "0", name: "All" });
        setDateRange(dr);
        setHistoryParam("");
        DoSearch();
    }

    const CreateParams = (dr) => {
        let st = String(GetSession().SiteID);
        var params = {
            FromDate: dr.start === null ? "2000-01-01T00:00:00Z" : dr.start.toISOString(),
            ToDate: dr.end === null ? "2050-01-01T00:00:00Z" : dr.end.toISOString(),
            Docket: docket.trim(),
            Rego: rego.trim(),
            Job: job.id,
            Customer: customer.id,
            Product: product.id,
            Source: source.id,
            Destination: destination.id,
            Site: st
        };
        return encodeURI(JSON.stringify(params));
    }


    const RowClick = (row) => {
        rowRef.current = row;
        const timeOffset = new Date().getTimezoneOffset() / 60;
        transId.current = row.transactionId;
        setSelectedTrans(String(row.transactionId));
        const baseUrl = (cloudToken !== undefined && cloudToken !== "" ? GetSession().CloudURL : configData.SERVER_URL);
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + (cloudToken !== undefined && cloudToken !== "" ? cloudToken : GetToken()) }
        };
        let url = `${baseUrl}apiv7/private/getdockettext?transactionid=${row.transactionId}&offset=${timeOffset}`;
        fetch(url, init).then(response => response.text()).then(d => {
            setMessage("");
            let dt = d.replace(/\[b\]/gi, "").replace(/\[\/b\]/gi, "");
            setDocketText(dt);
            let x = String(d).replace(/\r/g, "").split('\n');
            let t = "";
            x.map(s => {
                let line = s.replace(/\[b\]/gi, "<b>").replace(/\[\/b\]/gi, "</b>");
                let sp = line.split(':');
                if (sp.length > 1) {
                    t += `<tr><td class="ReprintLeft">${sp[0]}</td><td>: ${sp[1]}</td></tr>`;
                } else {
                    t += `<tr><td colspan="2">${s}</td></tr>`
                }
            });
            let pv = "";
            if (logo !== undefined) pv += `<img src='${logo}' />`;
            pv += "<table style='font-family: \'Segoe UI\',Arial'>" + t + "</table>";
            setPrintText(pv);
        });
        url = `${baseUrl}apiv7/camerasnapshots?$filter = transactionid eq ${row.transactionId}`;
        fetch(url, init).then(response => response.text()).then(d => {
            let sn = JSON.parse(d);
            if (sn !== undefined && sn.length > 0) {
                let fw = [];
                if (sn[0].firstWeighSnapshot1 !== "") fw.push(sn[0].firstWeighSnapshot1);
                if (sn[0].firstWeighSnapshot2 !== "") fw.push(sn[0].firstWeighSnapshot2);
                if (sn[0].firstWeighSnapshot3 !== "") fw.push(sn[0].firstWeighSnapshot3);
                if (sn[0].firstWeighSnapshot4 !== "") fw.push(sn[0].firstWeighSnapshot4);
                setFirstWeighs(fw);
                let ss = [];
                if (sn[0].snapshot1 !== "") ss.push(sn[0].snapshot1);
                if (sn[0].snapshot2 !== "") ss.push(sn[0].snapshot2);
                if (sn[0].snapshot3 !== "") ss.push(sn[0].snapshot3);
                if (sn[0].snapshot4 !== "") ss.push(sn[0].snapshot4);
                setSnapshots(ss);
            }
        });
        let prm = {Rego: row.registration1};
        setHistoryParam(encodeURI(JSON.stringify(prm)));
    }

    const PrintDocket = () => {
        setShowDialog(false);
        setTimeout(PrintPreview, 50);
    }

    const PrintPreview = () => {
        document.title = "Reprint docket #" + rowRef.current.docket;
        window.onafterprint = () => {
            document.title = title;
            setShowDialog(true);
            if (props.onClose) props.onClose();
        }
        window.print();
    }

    const regoChanged = (e) => { setRego(e.value); }
    const docketChanged = (e) => { setDocket(e.value); }
    const jobChanged = (e) => { setJob(e.value); }
    const customerChanged = (e) => { setCustomer(e.value); }
    const productChanged = (e) => { setProduct(e.value); }
    const sourceChanged = (e) => { setSource(e.value); }
    const destinationChanged = (e) => { setDestination(e.value); }

    const bulkExport = (rec) => {
        const timeOffset = new Date().getTimezoneOffset() / 60;
        const baseUrl = (props !== undefined && props !== "" ? GetSession().CloudURL : configData.SERVER_URL);
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + (cloudToken !== undefined && cloudToken !== "" ? cloudToken : GetToken()) }
        };
        var url = `${baseUrl}apiv7/private/getdocketzip?ids=${rec}&offset=${timeOffset}`;
        fetch(url, init).then(response => response.blob()).then(d => {
            var fileURL = URL.createObjectURL(d);
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.download = `docket.zip`;
            fileLink.click();
        });
    }

    return (
        <div>
            {!showDialog && <div id="ReprintPage" dangerouslySetInnerHTML={{ __html: printText }}></div>}
            {showDialog && <Dialog id="ReprintDialog" title="Reprint Docket" onClose={DialogNo}>
            <div className="row">
                <div className="col-md-3">
                    <div className="row" style={{ paddingBottom: "10px" }}>
                        <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged} />
                    </div>
                    {GetField("searchRego")["isVisible"] && <div className="row" style={{ paddingBottom: "10px" }}>
                        <label className="control-label">{GetField("searchRego")["label"]}</label>
                        <TextBox autoFocus id="Rego" type="text" value={rego} onChange={regoChanged} />
                    </div>}
                    {GetField("searchDocket")["isVisible"] && <div className="row" style={{ paddingBottom: "10px" }}>
                        <label className="control-label">{GetField("searchDocket")["label"]}</label>
                        <TextBox id="Docket" type="text" value={docket} onChange={docketChanged} />
                    </div>}
                    {GetField("searchJob")["isVisible"] && <div className="row" style={{ paddingBottom: "10px" }}>
                        <label className="control-label">{GetField("searchJob")["label"]}</label>
                        <DropDownList id="Job" data={jobs} value={job} textField="name" dataItemKey="id" onChange={jobChanged} />
                    </div>}
                    {GetField("searchCustomer")["isVisible"] && <div className="row" style={{ paddingBottom: "10px" }}>
                        <label className="control-label">{GetField("searchCustomer")["label"]}</label>
                        <DropDownList id="Customer" data={customers} value={customer} textField="name" dataItemKey="id" onChange={customerChanged} />
                    </div>}
                    {GetField("searchProduct")["isVisible"] && <div className="row" style={{ paddingBottom: "10px" }}>
                        <label className="control-label">{GetField("searchProduct")["label"]}</label>
                        <DropDownList id="Product" data={products} value={product} textField="name" dataItemKey="id" onChange={productChanged} />
                    </div>}
                    {GetField("searchSource")["isVisible"] && <div className="row" style={{ paddingBottom: "10px" }}>
                        <label className="control-label">{GetField("searchSource")["label"]}</label>
                        <DropDownList id="Source" data={sources} value={source} textField="name" dataItemKey="id" onChange={sourceChanged} />
                    </div>}
                    {GetField("searchDestination")["isVisible"] && <div className="row" style={{ paddingBottom: "20px" }}>
                        <label className="control-label">{GetField("searchDestination")["label"]}</label>
                        <DropDownList id="Product" data={destinations} value={destination} textField="name" dataItemKey="id" onChange={destinationChanged} />
                    </div>}
                    <div className="row">
                        <div className="col-md-4"><Button onClick={DialogNo} themeColor={"tertiary"}>Back</Button></div>
                            <div className="col-md-4"><Button onClick={DoClear}>Clear</Button></div>
                        <div className="col-md-4"><Button onClick={DoSearch} themeColor={"primary"}>Search</Button></div>
                    </div>
                </div>
                <div id="ReprintGrid" className="col-md-4">
                        <DataGrid dataSource='apiv7/transactions' viewName='Transactions' columns={columns} permissions={permissions} params={lookupParams} keyField="transactionId" onRowClick={RowClick} bulkExport={bulkExport} cloudToken={cloudToken} selectedId={selectedTrans} />
                </div>
                <div className="col-md-5">
                    <TabStrip selected={selectedTab} onSelect={handleTabSelect}>
                            {(docketText !== "" || message !== "") && <TabStripTab title="Docket">
                                <div style={{ minWidth: "450px"}}>
                                    {docketText !== "" && <div className="row">
                                        <Button onClick={PrintDocket} themeColor={"primary"}>Print</Button>{" "}
                                    </div>}
                                    {docketText !== "" && <div className="row">
                                        <TextArea rows={30} columns={62} value={docketText} className="DocketText" />
                                    </div>}
                                    {message !== "" && <div>{message}</div>}
                                </div>
                        </TabStripTab>}
                        {snapshots.length > 0 && <TabStripTab title="Snapshots">
                            {snapshots.length > 0 && <div className="row"><img src={snapshots[0]} className={"cameraSnapshotLarge"} alt="Snapshot 1" /></div>}
                            {snapshots.length > 1 && <div className="row"><img src={snapshots[1]} className={"cameraSnapshotLarge"} alt="Snapshot 2" /></div>}
                            {snapshots.length > 2 && <div className="row"><img src={snapshots[2]} className={"cameraSnapshotLarge"} alt="Snapshot 3" /></div>}
                            {snapshots.length > 3 && <div className="row"><img src={snapshots[3]} className={"cameraSnapshotLarge"} alt="Snapshot 4" /></div>}
                        </TabStripTab>}
                        {firstWeighs.length > 0 && <TabStripTab title="Firstweighs">
                            {firstWeighs.length > 0 && <div className="row"><img src={firstWeighs[0]} className={"cameraSnapshotLarge"} alt="First Weigh Snapshot 1" /></div>}
                            {firstWeighs.length > 1 && <div className="row"><img src={firstWeighs[1]} className={"cameraSnapshotLarge"} alt="First Weigh Snapshot 1" /></div>}
                            {firstWeighs.length > 2 && <div className="row"><img src={firstWeighs[2]} className={"cameraSnapshotLarge"} alt="First Weigh Snapshot 1" /></div>}
                            {firstWeighs.length > 3 && <div className="row"><img src={firstWeighs[3]} className={"cameraSnapshotLarge"} alt="First Weigh Snapshot 1" /></div>}
                        </TabStripTab>}
                            {historyParam !== "" && <TabStripTab title="Vehicle History">
                                <div style={{maxHeight: "700px"} }>
                                    <DataGrid dataSource='apiv7/eventlogs' columns={eventColumns} permissions={{}} keyField="eventLogId" params={historyParam}/>
                            </div>
                        </TabStripTab>}
                            {historyParam !== "" && <TabStripTab title="Offences">
                                <div style={{ maxHeight: "700px" }}>
                                    <DataGrid dataSource='apiv7/offences' columns={offenceColumns} permissions={{}} keyField="offenceId" params={historyParam} />
                                </div>
                            </TabStripTab>}
                    </TabStrip>
                </div>
            </div>
            </Dialog>}
        </div>
    );
}

